import React, { useEffect, useState } from "react";
import BreadCrumb from "../../Common/BreadCrumb";
import {
    Card,
    CardBody,
    Col,
    Container,
    Row,
    Form,
    FormGroup,
    Button,
    Label,
    Input,
    FormFeedback,
} from "reactstrap";
import InputField from "../../Utils/InputField";
import SelectField from "../../Utils/SelectField";
import { Formik } from "formik";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addUnitOfMeasurement } from "../../../slices/uom/adduom/thunk";
import { ToastContainer } from "react-toastify";
import { initialFormValues, RoundingRuleOptions, validationSchema } from "./constants/initialvalues";
import { Loader } from "../../Utils/Loader";
import { uomJsonObj } from "./constants/uomsubmit";
import { LabelText } from "../../Utils/Input";
import CommonButton from "../../Utils/CommonButton";
import { PAGE_TITLES } from "../../Common/constants";
import formSchema from "../../Utils/schema.json";
import { RenderField } from "../../Utils/renderFields";
import { ValueTypeOptions } from "./constants/initialvalues";
import { RenderErrorMessage } from "../../Utils/renderErrorMessages";
import { editUom } from "../../../slices/uom/updateUom/thunk";
import { customerIdData } from "../../Customers/constants/constantFunctionsView";
import { getUomById } from "../../../slices/uom/getUomByName/thunk";
import { useSelector } from 'react-redux';
import { hasPermission } from '../../Utils/UtilityFunctions';

export const UmoForm = ({
    initialAIUomValues,
    toggle,
    setModalOpen,
    initialData,
    isEditMode,
    triggerRefresh,
}) => {
    let navigate = useNavigate();
    let dispatch = useDispatch();
    const uomName = isEditMode ? initialData.name : "";
    const isEdit = isEditMode;
    const isAiPath = location.pathname.includes("chatbot");
    const isCreate = !isEditMode;
    const [loading, setLoading] = useState(false);
    const [enableReinitialize, setEnableReinitialize] = useState(false);

    const rawPermissions = useSelector(
            (state) => state.permissions.permissionsMap
        );
    
        const permissionsMap = new Map(
            rawPermissions.map(([key, value]) => [key, new Set(value)])
        );
        const uomInventoryPermission = hasPermission(permissionsMap, "configuration", "uom")

    const uomLabel = uomInventoryPermission?.has("list") ? "Unit" : "UOM";

    let initialValues = {
        name: isEdit ? initialData.name : "",
        valuetype: isEdit ? ValueTypeOptions.find(attr => attr.name === 'valuetype')?.options?.find(option => option.value === initialData.valueType) : "",
        stepQuantity: isEdit ? initialData.stepQuantity : "",
        roundingRule: isEdit && initialData.roundingRule
            ? RoundingRuleOptions.find(attr => attr.name === 'roundingRule')?.options?.find(option => option.value === initialData.roundingRule)
            : null,
    }

    const onSubmit = (values) => {

        const jsonObj = uomJsonObj(values);
        submitUom(jsonObj);
    };

    // if (isEdit) {
    // useEffect(() => {
    // dispatch(
    // getUomById(setLoading, uomName, initialValues, ValueTypeOptions)
    // );
    // }, [dispatch]);
    // }

    useEffect(() => {
        if (isCreate) {
            setEnableReinitialize(true);
        }
    }, [isCreate]);

    const submitUom = (jsonObj) => {
        if (isEdit) {
            dispatch(editUom(jsonObj, uomName, setLoading, navigate, triggerRefresh,toggle));
        } else {
            dispatch(
                addUnitOfMeasurement(jsonObj, setLoading, navigate, triggerRefresh,toggle)
            );
        }
    };

    return (
        <React.Fragment>
            <Formik
                validationSchema={validationSchema}
                initialValues={
                    isAiPath ? initialAIUomValues.initialAIUomValues : initialValues
                }
                onSubmit={async (values) => {
                    if (values.name !== "" && values.valuetype !== "") {
                        onSubmit(values);
                    }
                }}
                enableReinitialize={enableReinitialize}
            >
                {({
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    errors,
                    touched,
                    values,
                    setFieldValue,
                    setFieldTouched,
                }) => (
                    <Form className="needs-validation" onSubmit={handleSubmit}>
                        <Container fluid>
                            <ToastContainer position="top-center" />
                            <Row>
                                <Col lg={12}>
                                    <div className="listingjs-table " id="customerList">
                                        <div className="shadow-none">
                                            <CardBody className="card-body">
                                                <Row>
                                                    <Col lg={6} sm={12}>
                                                        <FormGroup>
                                                            <LabelText
                                                                htmlFor={"name"}
                                                                classLabelName={"ms-0 rv-form-label"}
                                                                className={"ms-1 text-danger"}
                                                                displayText={`${uomLabel} Name`}
                                                                important={"*"}
                                                            />
                                                            <LabelText
                                                                htmlFor={"name"}
                                                                classLabelName={`d-block ms-0 rv-sub-label ${touched.name && errors.name
                                                                    ? "rv-label-danger"
                                                                    : "rv-label-muted"
                                                                    } `}
                                                                displayText={
                                                                    touched.name && errors.name
                                                                        ? errors.name
                                                                        : `Enter ${uomLabel} Name`
                                                                }
                                                            />
                                                            <InputField
                                                                name={"name"}
                                                                type={"text"}
                                                                className={"form-control"}
                                                                id={"name"}
                                                                handleChange={handleChange}
                                                                handleBlur={handleBlur}
                                                                value={values.name}
                                                                invalid={
                                                                    touched.name && errors.name ? true : false
                                                                }
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col lg={6} sm={12}>
                                                        <FormGroup>
                                                            <LabelText
                                                                htmlFor={"valuetype"}
                                                                classLabelName={"ms-0 rv-form-label"}
                                                                className={"text-danger"}
                                                                displayText={"Value Type"}
                                                                important={"*"}
                                                            />
                                                            <LabelText
                                                                htmlFor={"valuetype"}
                                                                classLabelName={`d-block ms-0 rv-sub-label ${touched.valuetype && errors.valuetype
                                                                    ? "rv-label-danger"
                                                                    : "rv-label-muted"
                                                                    } `}
                                                                displayText={
                                                                    touched.valuetype && errors.valuetype
                                                                        ? errors.valuetype
                                                                        : `Select Value Type`
                                                                }
                                                            />
                                                            <SelectField
                                                                className={
                                                                    (errors.valuetype && touched.valuetype) ||
                                                                        false
                                                                        ? "error-input"
                                                                        : ""
                                                                }
                                                                value={values.valuetype}
                                                                placeholder={" "}
                                                                handleChange={(e) => {
                                                                    setFieldValue("valuetype", e);
                                                                }}
                                                                isRVStyle={true}
                                                                options={ValueTypeOptions}
                                                                invalid={
                                                                    touched.valuetype && errors.valuetype
                                                                        ? true
                                                                        : false
                                                                }
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col lg={6} sm={12}>
                                                        <FormGroup>
                                                            <LabelText
                                                                htmlFor={"stepQuantity"}
                                                                classLabelName={"ms-0 rv-form-label"}
                                                                className={"ms-1 text-danger"}
                                                                displayText={"Step Quantity"}

                                                            />
                                                            <LabelText
                                                                htmlFor={"stepQuantity"}
                                                                classLabelName={`d-block ms-0 rv-sub-label ${touched.stepQuantity && errors.stepQuantity
                                                                    ? "rv-label-danger"
                                                                    : "rv-label-muted"
                                                                    } `}
                                                                displayText={

                                                                    "Enter Step Quantity"
                                                                }
                                                            />
                                                            <InputField
                                                                name={"stepQuantity"}
                                                                type={"number"}
                                                                className={"form-control"}
                                                                id={"stepQuantity"}
                                                                handleChange={handleChange}
                                                                handleBlur={handleBlur}
                                                                value={values.stepQuantity}
                                                                invalid={
                                                                    touched.stepQuantity && errors.stepQuantity ? true : false
                                                                }
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col lg={6} sm={12}>
                                                        <FormGroup>
                                                            <LabelText
                                                                htmlFor={"roundingRule"}
                                                                classLabelName={"ms-0 rv-form-label"}
                                                                className={"text-danger"}
                                                                displayText={"Rounding Rule"}

                                                            />
                                                            <LabelText
                                                                htmlFor={"roundingRule"}
                                                                classLabelName={`d-block ms-0 rv-sub-label ${touched.roundingRule && errors.roundingRule
                                                                    ? "rv-label-danger"
                                                                    : "rv-label-muted"
                                                                    } `}
                                                                displayText={

                                                                    `Select Rounding Rule`
                                                                }
                                                            />
                                                            <SelectField

                                                                value={values.roundingRule}
                                                                placeholder={" "}
                                                                handleChange={(e) => {
                                                                    setFieldValue("roundingRule", e);
                                                                }}
                                                                isRVStyle={true}
                                                                options={RoundingRuleOptions}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                </Row>

                                            </CardBody>
                                        </div>
                                        <div class="d-flex justify-content-center gap-2 w-50 m-auto mt-3 mb-2">
                                            <button
                                                type="button"
                                                className="btn-label rv-secondary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap btn btn-secondary"
                                                onClick={() => {
                                                    toggle();
                                                }}
                                            >
                                                <i class="ri-close-line label-icon secondary-label-icon align-middle fs-16 me-2"></i>
                                                <span class="px-2 ps-3 ms-2 me-1">Cancel</span>
                                            </button>

                                            <button
                                                type="submit"
                                                class="btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap btn btn-secondary"
                                            >
                                                <i class="ri-checkbox-circle-line label-icon align-middle fs-16 me-1"></i>
                                                <span class="ps-2 ms-2 me-1">Submit</span>
                                            </button>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </Form>
                )}
            </Formik>
            {loading && <Loader />}
        </React.Fragment>
    );
};